<template>
	<div>
		<header-section icon="" title="">
			<template slot="buttons">
				<el-button
						size="medium"
						type="danger"
						icon="el-icon-arrow-left"
						@click="$router.push('/inicio')">
					Regresar
				</el-button>
			</template>
		</header-section>

		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<span>Cambio de centro de trabajo</span>
			</div>
			<div>
				Si deseas darte de baja del plan de capacitación, debes asumir las siguientes responsabilidades
				<hr class="white-line-5">
				<ul>
					<li><p>Quedarás en primera baja dentro de la plataforma</p></li>
					<li><p>Solo tendrás UNA oportunidad más para vincularte a otro plan de capacitación</p></li>
					<li><p>Recuerda que después de tu segunda baja ya no podrás vincularte a otra empresa.</p></li>
				</ul>

			</div>
			<br/>
			<ProfileOfTraining :info="info" v-if="info"/>
			<br/>
			<el-row v-if="!onlyRead && loaded == true && infoPerson.isCompleteToTheProgram == 0">
				<el-col align="center">
					<el-button type="primary" @click="requestChange()">
						Solicitar cambio
					</el-button>
				</el-col>
			</el-row>

		</el-card>
	</div>
</template>

<script>
	import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';

	const HeaderSection = _ => import(/* webpackChunkName: "js/split/HeaderSection" */'@/components/partials/HeaderSection');
	const ProfileOfTraining = _ => import(/* webpackChunkName: "js/split/ProfileOfAdvisor" */'@/components/partials/ProfileOfTraining');
	import store from "@/store/index.js";

	export default {

		components: {
			HeaderSection,
			ProfileOfTraining
		},
		computed: {
			...mapGetters('young', {
				infoPerson: 'person'
			}),
			...mapGetters('youngSecondPart', {
				onlyRead: 'onlyRead',
				totalTraining: 'totalTraining',
				loaded: 'loaded'
			}),
			...mapGetters({
				userInfo: "userInfo"
			}),
			info() {
				return this.infoPerson && this.infoPerson.people_advisor_training &&
				this.infoPerson.people_advisor_training.advisor_training_plans ?
					this.infoPerson.people_advisor_training.advisor_training_plans : null;
			}
		},
		methods: {
			...mapActions('young', {
				fetchSigle: "fetchSigle",
			}),
			...mapActions('youngSecondPart', {
				serviceGetTraining: "serviceGetTraining"
			}),
			iniOnlyProfile() {
				return this.fetchSigle().then((res) => {}).catch((err) => {});
			},
			serviceRefreshUser() {
				return window.axios.get("/api/user")
					.then(response => {
						if (response && response.data && response.data.user) {
							store.commit("setUser", response.data.user);
						}
						return true;
					}).catch(error => {

						return Promise.reject(error);
					});
			},
			requestChange() {

				let _this = this;
				let typeCompany = this.info.advisor_work_center.advisor.cat_advisor_type_id == 1 ? 'empresa' : (this.info.advisor_work_center.advisor.cat_advisor_type_id == 2 ? 'organización social' : 'institución pública');
				let companyName = this.info.advisor_work_center.advisor.name;

				let additional = this.totalTraining == 2 ?
					`<ul>
					<li><p>Recuerda que  ya no podrás vincularte a otra empresa.</p></li>
					</ul>` : `<ul>
					<li><p>Solo tendrás UNA oportunidad más para vincularte a otro plan de capacitación</p></li>
					<li><p>Recuerda que después de tu segunda baja ya no podrás vincularte a otra empresa.</p></li>
				</ul>`;
				this.$confirm(`¿Estás seguro de darte de baja de la ${typeCompany} "<strong>${ companyName }</strong>"?<br/>
				${ additional }`, 'Alerta', {
					confirmButtonText: 'Continuar',
					cancelButtonText: 'Cancelar',
					dangerouslyUseHTMLString: true,
					iconClass: 'el-icon-warning text-size-20 text-color-red',
					customClass: 'custom-message-box'
				}).then(() => {

					this.$confirm(`Al confirmar estarás validando  que LEÍSTE Y ACEPTAS tus responsabilidades al darte de baja.`, 'Confirmación', {
						confirmButtonText: 'Confirmar',
						cancelButtonText: 'Cancelar',
						dangerouslyUseHTMLString: true,
						iconClass: 'el-icon-warning text-size-20 text-color-red',
					}).then(() => {


						this.$store.dispatch('loading/spinner', {msg: 'Dando de baja...', status: true}, {root: true});

						var data = {
							id: null
						};

						window.axios.post(`/api/people-advisor/unsubscribe-from-the-company`, data)
							.then((response) => {
								console.log("response", response);
								this.$store.dispatch('loading/spinner', {}, {root: true});
								const parsedResponse = response.data;
								if (parsedResponse && parsedResponse.success == true) {

									this.$store.dispatch('notifications/ok', {msg: parsedResponse.message}, {root: true});

									Promise.all([this.serviceRefreshUser()])
										.then(() => {
											this.$router.push('/');
										})
										.catch((err) => {
											console.log("error", err)

										});

								}
							})
							.catch((err) => {
								this.$store.dispatch('loading/spinner', {}, {root: true});
								let msg = 'No se pudo completar la acción';
								if (err.response &&
									err.response.data &&
									err.response.data.message
									&& err.response.status == 400) {
									msg = err.response.data.message;
								}
								this.$store.dispatch('notifications/error', {msg: msg}, {root: true});

							});


					}).catch(() => {
						this.$message({
							type: 'info',
							message: 'Cancelado'
						});
					});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: 'Cancelado'
					});
				});
			}
		},
		created() {
			this.iniOnlyProfile();
		},
		mounted() {
			this.serviceGetTraining();
		},
	}
</script>

<style>

	.custom-message-box {
		width: 70%;
	}
</style>
